import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { ApiResponse } from '@card-software/nexus-utilities';

export interface ConsumableWarehouse {
  locationCode: string;
  name: { en: string; es: string };
  fullName?: { en: string; es: string };
}

@Injectable({
  providedIn: 'root',
})
export class LocationProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/location';

  getConsumableWarehouses(): Observable<ApiResponse<ConsumableWarehouse[]>> {
    return this.httpClient.get<ApiResponse<ConsumableWarehouse[]>>(`${this.baseUrl}/consumable-warehouses`);
  }
}
